import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getEffectivePermissions, hasAnyPermission, PERMISSIONS } from '../auth/permissions';

const RequireAuth = ({ children, roles = [], permissions = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '2rem' }}>Loading authentication...</div>;
  }

  if (!user || !user.email) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  const effective = getEffectivePermissions(user, {
    mockAdmin: process.env.REACT_APP_MOCK_ADMIN_USER === 'true',
  });

  const permissionCheck = () => {
    if (permissions.length > 0) {
      if (effective.isAdmin) return true;
      return hasAnyPermission(effective.permissions, permissions);
    }

    // Legacy role gating (backwards compatible)
    if (roles.length === 0) return true;
    if (effective.isAdmin) return true;

    const needs = roles.map(r => String(r).toLowerCase());
    // Only role we historically granted non-admin is Viewer => Packaging.User behavior
    if (needs.includes('viewer')) {
      return hasAnyPermission(effective.permissions, [PERMISSIONS.PackagingIndex]);
    }
    return false;
  };

  if (!permissionCheck()) {
    // denied marks "signed in but lacks permission" — UnauthorizedPage must
    // show Access Denied for this case, but bounce authenticated users home
    // when the flag is absent (e.g. landing on /unauthorized after a login
    // redirect or from a stale bookmark).
    return <Navigate to="/unauthorized" state={{ denied: true }} replace />;
  }

  return children;
};

export default React.memo(RequireAuth);
